import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import styles from "./notfound.module.scss";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/landing");
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.content}>
        <Typography variant="h1" className={styles.errorCode}>
          404
        </Typography>
        <Typography variant="h5" className={styles.title}>
          Page Not Found
        </Typography>
        <Typography variant="body1" className={styles.description}>
          The page you are looking for doesn't exist or has been moved.
        </Typography>
        <Button
          variant="contained"
          onClick={handleGoHome}
          className={styles.homeButton}
          startIcon={<HomeIcon />}
        >
          Go to Home
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;
